import classNames from "classnames"
import PlayTriangle from "~/icons/PlayTriangle"

export interface ThumbnailCircleProps {
  src: string
  alt?: string
  selected?: boolean
  isVideo?: boolean
  disabled?: boolean
  size?: "sm" | "md" | "lg"
  onClick?: () => void
  className?: string
}

const sizeClasses = {
  sm: "w-12 h-12",
  md: "w-16 h-16",
  lg: "w-20 h-20"
}

const ThumbnailCircle = ({
  src,
  alt = "",
  selected = false,
  isVideo = false,
  disabled = false,
  size = "md",
  onClick,
  className
}: ThumbnailCircleProps) => {
  return (
    <button
      type="button"
      onClick={onClick}
      disabled={disabled}
      className={classNames(
        "relative flex-shrink-0 rounded-full overflow-hidden focus:outline-none",
        sizeClasses[size],
        {
          "ring-2 ring-blue-500 ring-offset-2": selected,
          "bg-gray-200 cursor-not-allowed": disabled,
          "cursor-pointer": !disabled
        },
        className
      )}
    >
      {!disabled && (
        <img
          src={src}
          alt={alt}
          loading="lazy"
          className="w-full h-full object-cover select-none"
          draggable={false}
        />
      )}
      {isVideo && !disabled && (
        <span className="absolute inset-0 flex items-center justify-center">
          <PlayTriangle className="w-8 h-8 drop-shadow-md" />
        </span>
      )}
    </button>
  )
}

ThumbnailCircle.displayName = "ThumbnailCircle"

export { ThumbnailCircle }
export default ThumbnailCircle
